var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgClosedButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9996,
    cy: 15.9996,
    r: 14.4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29289 21.2567C8.90237 21.6472 8.90237 22.2804 9.29289 22.6709C9.68342 23.0614 10.3166 23.0614 10.7071 22.6709L15.9821 17.396L21.2934 22.7073C21.6839 23.0978 22.3171 23.0978 22.7076 22.7073C23.0981 22.3168 23.0981 21.6836 22.7076 21.2931L17.3963 15.9818L22.671 10.7071C23.0615 10.3166 23.0615 9.68342 22.671 9.29289C22.2805 8.90237 21.6473 8.90237 21.2568 9.29289L15.9821 14.5676L10.7437 9.32927C10.3532 8.93875 9.72004 8.93875 9.32952 9.32927C8.93899 9.71979 8.93899 10.353 9.32952 10.7435L14.5678 15.9818L9.29289 21.2567Z",
    fill: "#252129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgClosedButton);
export default __webpack_public_path__ + "static/media/imgClosedButton.e1d00334379c6288a4ea953a3253fefa.svg";
export { ForwardRef as ReactComponent };